<template>
    <div class="dash-global">
        <div class="stats">
            <!--img center  src="@/assets/logo.png" width="350" alt="logo"!-->
        </div>
        <b-modal
            id="modalCompany"
            ref="modal"
            title-tag="h6"
            title="Company"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="setCompany"
        >
            <b-form-select
                id="company-id"
                :options="companys"
                v-model="company.id"
            />
        </b-modal>
    </div>
</template>

<script>
import { userKey, companykey, searchglobalkey } from '@/global'
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'

export default {
    name: 'DashGlobal',
    components: {},
    computed: mapState(['user', 'compan']),
    data: function() {
        return {
            stat: {},
            company: {},
            companys: [],
            usernew: {},
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark'
        }
    },
    methods: {
        getSats() {
            axios.get(`${baseApiUrl}/stats`).then(res => (this.stat = res.data))
        },
        logout() {
            localStorage.removeItem(userKey)
            localStorage.removeItem(companykey)
            localStorage.removeItem(searchglobalkey)
            this.$store.commit('setUser', null)
            this.$store.commit('setCompan', null)
            this.$store.commit('setSearchGlobal', null)
            this.$router.push({ name: 'auth' })
        },
        setCompany() {
            axios
                .post(`${baseApiUrl}/setCompany`, this.company)
                .then(res => {
                    localStorage.removeItem(companykey)
                    this.$store.commit('setCompan', res.data)
                    localStorage.setItem(companykey, JSON.stringify(res.data))
                    this.hideModal()
                })
                .catch(showError)
        },
        loadCompanys() {
            const url = `${baseApiUrl}/companysuserscompanys/${this.user.id}`
            axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return {
                        ...company,
                        value: company.id,
                        text: company.name_company
                    }
                })
            })
        },
        loadPaymentRemind() {
            const url = `${baseApiUrl}/createmailfinancialaboutexpires/${this.compan.id}`
            axios.get(url)
            
        },
        openModalCompany() {
            if(!this.compan){
                 this.$bvModal.show('modalCompany')
            }
           
        },
        hideModal() {
            this.$bvModal.hide('modalCompany')
        }
    },
    mounted() {
        this.loadCompanys(), this.openModalCompany()
        this.loadPaymentRemind()
    }
}
</script>

<style>
.dash-global {
    width: 100%;
    background: url(./../../assets/logo.png) no-repeat;
    background-size: 400px;
    padding-top: 600px;
    background-position: center;
}
.stats {
    display: flex;
    padding: 100px 150px 150px 540px;
    justify-content: space-between;
    flex-wrap: wrap;
    text-align: center;
}

.stats {
    font-size: 0.8rem;
}
</style>
